import { TimeTrackingPage } from '@juvare/missions/ui/features/time-tracking';
import { Box } from '@mui/material';
import React from 'react';
import { MissionProvider } from '../missions';

export const RmsTimeTrackingPage: React.FC = () => {
    return (
        <Box sx={{ height: '100%', overflow: 'auto' }}>
            <MissionProvider>
                <TimeTrackingPage />
            </MissionProvider>
        </Box>
    );
};
